import type { ConsolePermissionKey } from '@sentinel/shared';
import { useAuthStore } from '@sentinel/web-core';

/** Whether the platform role of this session holds a console permission. The interface only
 *  hides; every route checks again on the server. */
export function useConsoleCan(permission: ConsolePermissionKey): boolean {
  const permissions = useAuthStore((s) => s.me?.consolePermissions ?? []);
  return permissions.includes(permission);
}
